import './vendor/pdf-flip/pflip/css/pdfflip.css'

import './vendor/pdf-flip/pflip/js/jquery.min'
import './vendor/pdf-flip/pflip/js/loader'
import './vendor/pdf-flip/pflip/js/pdfflip'
import './vendor/pdf-flip/index'